import RedirectButton from "../controllers/RareRedirect/RareRedirect";

const rareRedirect = (path) => ({
    path,
    component: RedirectButton,
});

export default rareRedirect;
